// extracted by mini-css-extract-plugin
export default {"buttons":"window_vote_buttons__85dQs"};